module.exports = __webpack_public_path__ + "static/media/footer-linear-dark.1955f166.svg";